import tryConversionToE164Format from './convert_to_E164';

const CALENDLY_BASE_URL = 'https://calendly.com/daniel-carequilt/care-plan-call-with-daniel';

const buildBlakeCalendlyLink = ({user, clientData} = {}) => {
  const userRn = user?.userRn;
  const userEmail = user?.email;
  const userFirstName = user?.firstName;
  const userLastName = user?.lastName;
  const userContacts = clientData?.clientDetail?.relationships?.[userRn]?.contacts ?? [];

  const rawUserPhoneNumber = userContacts.find((contactObj) => contactObj.type === 'Phone')?.detail ?? null;
  let convertedUserPhoneNumber = null;
  if (rawUserPhoneNumber) {
    convertedUserPhoneNumber = tryConversionToE164Format(rawUserPhoneNumber);
  }

  const queryParams = {};
  if (userRn) {
    queryParams.utm_term = userRn;
  }

  if (convertedUserPhoneNumber) {
    queryParams.location = convertedUserPhoneNumber;
  }

  if (userEmail) {
    queryParams.email = userEmail;
    queryParams.utm_source = userEmail;
  }

  if (userFirstName) {
    queryParams.first_name = userFirstName;
  }

  if (userLastName) {
    queryParams.last_name = userLastName;
  }

  const queryString = new URLSearchParams(queryParams).toString();
  return queryString ? `${CALENDLY_BASE_URL}?${queryString}` : CALENDLY_BASE_URL;
};

export default buildBlakeCalendlyLink;
